import apiClient from './apiClient';

const bankAccountsService = {
  // Get all bank accounts for current authenticated user
  getMerchantBankAccounts: async () => {
    // Session-based: uses authenticated user from req.user
    const response = await apiClient.get('/bankAccounts');
    return response.data;
  },
  
  // Get single bank account
  getBankAccount: async (bankAccountId) => {
    const response = await apiClient.get(`/bankAccounts/id/${bankAccountId}`);
    return response.data;
  },
  
  // Create bank account
  createBankAccount: async (data) => {
    const response = await apiClient.post('/bankAccounts', data);
    return response.data;
  },
  
  // Update bank account
  updateBankAccount: async (bankAccountId, data) => {
    const response = await apiClient.put(`/bankAccounts/${bankAccountId}`, data);
    return response.data;
  },
  
  // Delete bank account
  deleteBankAccount: async (bankAccountId) => {
    const response = await apiClient.delete(`/bankAccounts/${bankAccountId}`);
    return response.data;
  }
};

export default bankAccountsService;